export const REQUEST_CONTENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  EXPIRED: 'expired',
} as const;

export const BACKEND_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
} as const;

export const EXPIRATION_OPTIONS = [
  { label: 'Never', value: null },
  { label: 'in 1 hour', value: 1 },
  { label: 'in 1 day', value: 24 },
  { label: 'in 1 week', value: 168 },
  { label: 'in 1 month', value: 720 },
];

export const COLLECTION_SELECTION = {
  AUTO: 'auto',
  PICK: 'pick',
  MANUAL: 'manual',
} as const;

export type CollectionSelection = (typeof COLLECTION_SELECTION)[keyof typeof COLLECTION_SELECTION];

export type RequestContentStatus = (typeof REQUEST_CONTENT_STATUS)[keyof typeof REQUEST_CONTENT_STATUS];

export const computeStatus = (backendStatus: any, expiresAt?: string): RequestContentStatus => {
  if (expiresAt && new Date() > new Date(expiresAt)) {
    return REQUEST_CONTENT_STATUS.EXPIRED;
  }
  // Handle different backend status formats: boolean, number, or string
  const isActive = backendStatus === true || backendStatus === 1 || backendStatus === '1' || backendStatus === 'active';
  return isActive ? REQUEST_CONTENT_STATUS.ACTIVE : REQUEST_CONTENT_STATUS.INACTIVE;
};

export const getBackendStatus = (status: RequestContentStatus): number => {
  return status === REQUEST_CONTENT_STATUS.ACTIVE ? BACKEND_STATUS.ACTIVE : BACKEND_STATUS.INACTIVE;
};

// Modal view constants
export const MODAL_VIEWS = {
  FORM: 'FORM',
  SUCCESS: 'SUCCESS',
  EDIT_URL: 'EDIT_URL',
} as const;

export type ModalView = (typeof MODAL_VIEWS)[keyof typeof MODAL_VIEWS];

// Modal titles
export const MODAL_TITLES = {
  CREATE_REQUEST_LINK: 'Create Request Link',
  EDIT_REQUEST_LINK: 'Edit Request Link',
} as const;

// Slide animation classes
export const SLIDE_CLASSES = {
  SUCCESS: 'slide-success',
  EDIT_URL: 'slide-edit-url',
  COLLECTION: 'slide-collection',
} as const;
